var escape = require("../../../../../../../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoPlayBtn_2ksMjaaG {\n  width: 1.306667rem;\n  height: 1.306667rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 80;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.playingBtn_xIsd1Fcr {\n  background-image: url('https://x0.ifengimg.com/cmpp/2020/0313/d16118b0bbddf15size3_w98_h98.png');\n}\n\n.pauseBtn_3S_EHpcK {\n  background-image: url('https://x0.ifengimg.com/cmpp/2020/0321/5c091c6faa74a99size2_w98_h98.png');\n}\n\n.replayBtn_2gB-xG4H {\n  background-image: url(" + escape(require("./replay.png")) + ");\n}", ""]);

// exports
exports.locals = {
	"videoPlayBtn": "videoPlayBtn_2ksMjaaG",
	"playingBtn": "playingBtn_xIsd1Fcr",
	"pauseBtn": "pauseBtn_3S_EHpcK",
	"replayBtn": "replayBtn_2gB-xG4H"
};